import React, { useState } from 'react'

// Appt Components
import Box from '../../components/simple/box/Box.js'
import FontAwesome from '../../components/compound/fontAwesome/FontAwesome.js'
import Form from '../../components/simple/form/Form.js'
import FormField from '../../components/simple/formField/FormField.js'
import Divider from '../../components/simple/divider/Divider.js'
import H2 from '../../components/simple/heading/H2.js'
import ResponsiveGrid from '../../components/compound/responsiveGrid/ResponsiveGrid.js'
import Text from '../../components/simple/text/Text.js'
import TextArea from '../../components/simple/input/TextArea.js'
import TextInput from '../../components/simple/input/TextInput.js'

import CommentsForm from './CommentsForm.js';
import ActionButton from '../../components/compound/actionButton/ActionButton.js'
import Button from '../../components/simple/button/Button.js'
import { ResponsiveContext } from 'grommet'


function BehaviourDetails (props) {
  const [questions, setQuestions] = useState(props.questions)
  const [localIncidentValues, setLocalIncidentValues] = useState(props.incidentValues)

  const [editingDisabled] = useState(props.formId && props.status !== 'draft');


  const previousPage = () => {
    props.previousPage(localIncidentValues)
  }

  const nextPage = () => {
    props.nextPage(localIncidentValues)
  }

  // Submit form values
  const submitForm = async () => {
    props.submitForm(localIncidentValues, 'Draft')
  }
  // auto save every 15 seconds
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     // buildTechniqueArray()
  //     props.submitForm(localIncidentValues, 'Draft')
  //   }, 15000)
  //   return () => clearInterval(interval) // Clear the interval on component unmount
  // }, [])

  return (
    <ResponsiveContext.Consumer>
      {responsive => (
      <Box gridArea='main' background='white' direction='column' gap='small' round='small'>
        <Box
          gap='small'
          margin={{ horizontal: 'small' }}
          pad='small'
          round='small'
        >
          <Box fill direction='row' gap='small'>
            <H2 margin={{ vertical: 'none' }}>Behaviour Details</H2>
            <Button
              label={<Text><FontAwesome color='brand' icon={['fas', 'question-circle']} /></Text>}
              plain
              tip={{
                content: (
                  <Box background={{ color: 'white' }} border={{ color: 'brand', size: 'small' }} direction='column' pad='small'>
                    <Text>When completing the low to high level behaviour section what you put in the lowlevel medium level and high level boxes will be automatically added to the Smart Plan.</Text>
                    <Text>With this in mind if a child was tapping on a table we would input "tapping on table" if our response was we made the individual laugh we would just input the word "humour".</Text>
                  </Box>)
              }}
            />
          </Box>
          <Divider color='primary' margin={{ top: 'none', bottom: 'small' }} />
          <Form
            //   validate='blur'
            onChange={nextValue => {
              setLocalIncidentValues(nextValue)
            }}
            onSubmit={({ value: nextValue }) => {
              submitForm(nextValue)
            }}
            value={localIncidentValues}
          >
            <Box>
              {/* Description */}
              <FormField
                label={questions[9].questionText}
                name={questions[9].key}
              >
                {!editingDisabled && <TextArea
                  name={questions[9].key}
                />}
                {editingDisabled && <Text>{props.incidentValues?.[questions[9].key] || ''}</Text>}
              </FormField>
            </Box>


            <Box>
              <Text weight='bold' size='medium' margin={{ top: 'medium' }}>As concisely as possible:</Text>
            </Box>

            <Box>
              <Text weight='bold' margin={{ top: 'small' }}>Low Level Behaviour</Text>
            </Box>
            <ResponsiveGrid
              rows={['auto']}
              columns={{
                small: ['auto'],
                medium: ['auto'],
                large: ['auto', 'auto', 'auto'],
                xlarge: ['auto', 'auto', 'auto']
              }}
              gap='small'
            >
              {/* Low level behaviour student shows */}
              <FormField
                label={(
                  <Box fill direction='row' gap='small'>
                    <Text size='small'>{questions[0].questionText}</Text>
                    <Button
                      label={<Text><FontAwesome color='brand' icon={['fas', 'question-circle']} /></Text>}
                      plain
                      tip={{
                        content: (
                          <Box background={{ color: 'white' }} border={{ color: 'brand', size: 'small' }} direction='column' pad='small'>
                            <Text>Low level behaviours might include:</Text>
                            <Text>Making noises</Text>
                            <Text>Going quiet</Text>
                            <Text>Showing signs of anxiety</Text>
                            <Text>Hiding face in hands</Text>
                            <Text>Pulling down hat</Text>
                            <Text>Tapping</Text>
                            <Text>Withdrawing from group</Text>
                            <Text>Refusing to speak or dismissive</Text>
                            <Text>Refusing to co-operate</Text>
                            <Text>Eye contact increased or decreased</Text>
                            <Text>Changes in breathing</Text>
                          </Box>)
                        // dropProps: { background: 'red', extend: { border-width: '2px'; border-color: 'blue' } }
                      }}
                    />
                  </Box>)}
                name={questions[0].key}
                required
              >
                {!editingDisabled && <TextInput
                  name={questions[0].key}
                  type='text'
                />}
                {editingDisabled && <Text>{props.incidentValues?.[questions[0].key] || 'N/A'}</Text>}
              </FormField>

              {/* Low level how respond */}
              <FormField
                label={<Box height='40px'><Text size='small'>{questions[1].questionText}</Text></Box>}
                name={questions[1].key}
                required
              >
                {!editingDisabled && <TextInput
                  name={questions[1].key}
                  type='text'
                />}
                {editingDisabled && <Text>{props.incidentValues?.[questions[1].key] || 'N/A'}</Text>}

              </FormField>

              {/* Low level strategies */}
              <FormField
                label={(
                  <Box fill direction='row' gap='small'>
                    <Box height='40px'>
                      <Text size='small'>{questions[2].questionText}</Text>
                    </Box>
                    <Button
                      label={<Text><FontAwesome color='brand' icon={['fas', 'question-circle']} /></Text>}
                      plain
                      tip={{
                        content: (
                          <Box background={{ color: 'white' }} border={{ color: 'brand', size: 'small' }} direction='column' pad='small'>
                              <Text>Low level strategies might include:</Text>
                              <Text>1. Provide a calm environment.</Text>
                              <Text>2. Use gentle reassurance.</Text>
                              <Text>3. Encourage deep breathing.</Text>
                              <Text>4. Offer a fidget tool or sensory item.</Text>
                              <Text>5. Validate feelings.</Text>
                              <Text>6. Calming activity.</Text>
                              <Text>7. Create predictability and structure.</Text>
                              <Text>8. Model calmness.</Text>
                              <Text>9. Offer choices.</Text>
                              <Text>10. Encourage movement or stretching.</Text>
                          </Box>)
                        // dropProps: { background: 'red', extend: { border-width: '2px'; border-color: 'blue' } }
                      }}
                    />
                  </Box>)}

                name={questions[2].key}
                required
              >
                {!editingDisabled && <TextInput
                  name={questions[2].key}
                  type='text'
                />}
                {editingDisabled && <Text>{props.incidentValues?.[questions[2].key] || 'N/A'}</Text>}

              </FormField>

            </ResponsiveGrid>

            <Box>
              <Text weight='bold' margin={{ top: 'small' }}>Medium Level Behaviour</Text>
            </Box>
            <ResponsiveGrid
              rows={['auto']}
              columns={{
                small: ['auto'],
                medium: ['auto'],
                large: ['auto', 'auto', 'auto'],
                xlarge: ['auto', 'auto', 'auto']
              }}
              gap='small'
            >

              {/* Medium level behaviour student shows */}
              <FormField
                label={(
                  <Box fill direction='row' gap='small'>
                    <Text size='small'>{questions[3].questionText}</Text>
                    <Button
                      label={<Text><FontAwesome color='brand' icon={['fas', 'question-circle']} /></Text>}
                      plain
                      tip={{
                        content: (
                          <Box background={{ color: 'white' }} border={{ color: 'brand', size: 'small' }} direction='column' pad='small'>
                            <Text>Medium level behaviours might include:</Text>
                            <Text>Adopting defensive postures</Text>
                            <Text>Body position & tension- arms crossed</Text>
                            <Text>Clenched jaws or fists</Text>
                            <Text>Making personal and offensive remarks</Text>
                            <Text>Talking louder – higher - quicker</Text>
                            <Text>Adopting aggressive postures</Text>
                            <Text>Changes in eye contact</Text>
                            <Text>Pacing around</Text>
                            <Text>Breaking minor rules</Text>
                            <Text>Low level destruction</Text>
                            <Text>Picking up objects which could be used as weapons</Text>
                            <Text>Beligerant and abusive</Text>
                          </Box>),
                        dropProps: { plain: true }
                      }}
                    />
                  </Box>)}
                name={questions[3].key}
                required
              >
                {!editingDisabled && <TextInput
                  name={questions[3].key}
                  type='text'
                />}
                {editingDisabled && <Text>{props.incidentValues?.[questions[3].key] || 'N/A'}</Text>}
              </FormField>

              {/* Medium level how respond */}
              <FormField
                label={<Box height='40px'><Text size='small'>{questions[4].questionText}</Text></Box>}
                name={questions[4].key}
                required
              >
                {!editingDisabled && <TextInput
                  name={questions[4].key}
                  type='text'
                />}
                {editingDisabled && <Text>{props.incidentValues?.[questions[4].key] || 'N/A'}</Text>}
              </FormField>

              {/* Medium level strategies */}
              <FormField
                // label={<Box height='40px'><Text size='small'>{questions[5].questionText}</Text></Box>}
                label={(
                  <Box fill direction='row' gap='small'>
                    <Box height='40px'>
                      <Text size='small'>{questions[5].questionText}</Text>
                    </Box>
                    <Button
                      label={<Text><FontAwesome color='brand' icon={['fas', 'question-circle']} /></Text>}
                      plain
                      tip={{
                        content: (
                          <Box background={{ color: 'white' }} border={{ color: 'brand', size: 'small' }} direction='column' pad='small'>
                            <Text>Medium level strategies might include:</Text>
                            <Text>1. Give space.</Text>
                            <Text>2. Acknowledge feelings.</Text>
                            <Text>3. Use clear, simple language.</Text>
                            <Text>4. Offer a break.</Text>
                            <Text>5. Set boundaries for behavior.</Text>
                            <Text>6. Redirect focus.</Text>
                            <Text>7. Choices.</Text>
                            <Text>8. Use positive reinforcement.</Text>
                            <Text>9. Stay patient and give time.</Text>
                          </Box>)
                      }}
                      />
                  </Box>)}
                name={questions[5].key}
                required
              >
                {!editingDisabled && <TextInput
                  name={questions[5].key}
                  type='text'
                />}
                {editingDisabled && <Text>{props.incidentValues?.[questions[5].key] || 'N/A'}</Text>}
              </FormField>

            </ResponsiveGrid>

            <Box>
              <Text weight='bold' margin={{ top: 'small' }}>High Level Behaviour</Text>
            </Box>
            <ResponsiveGrid
              rows={['auto']}
              columns={{
                small: ['auto'],
                medium: ['auto'],
                large: ['auto', 'auto', 'auto'],
                xlarge: ['auto', 'auto', 'auto']
              }}
              gap='small'
            >

              {/* High level behaviour student shows */}
              <FormField
                label={(
                  <Box fill direction='row' gap='small'>
                    <Text size='small'>{questions[6].questionText}</Text>
                    <Button
                      label={<Text><FontAwesome color='brand' icon={['fas', 'question-circle']} /></Text>}
                      plain
                      tip={{
                        content: (
                          <Box background={{ color: 'white' }} border={{ color: 'brand', size: 'small' }} direction='column' pad='small'>
                            <Text>High level behaviours might include:</Text>
                            <Text>Hurting self</Text>
                            <Text>Hurting others</Text>
                            <Text>Damaging property</Text>
                            <Text>Throwing objects</Text>
                            <Text>Picking up objects which could be used as weapons</Text>
                            <Text>Kicking</Text>
                            <Text>Punching</Text>
                          </Box>)
                      }}
                    />
                  </Box>)}
                name={questions[6].key}
                required
              >
                {!editingDisabled && <TextInput
                  name={questions[6].key}
                  type='text'
                />}
                {editingDisabled && <Text>{props.incidentValues?.[questions[6].key] || 'N/A'}</Text>}

              </FormField>

              {/* High level how respond */}
              <FormField
                label={<Box height='40px'><Text size='small'>{questions[7].questionText}</Text></Box>}
                name={questions[7].key}
              >
                {!editingDisabled && <TextInput
                  name={questions[7].key}
                />}
                {editingDisabled && <Text>{props.incidentValues?.[questions[7].key] || 'N/A'}</Text>}

              </FormField>

              {/* High level strategies */}
              <FormField
                // label={(
                //   <Box fill direction='row' gap='small'>
                //     <Box height='40px'>
                //       <Text height='large' size='small'>{questions[8].questionText}</Text>
                //     </Box>
                //   </Box>)}
                label={(
                  <Box fill direction='row' gap='small'>
                    <Box height='40px'>
                      <Text height='large' size='small'>{questions[8].questionText}</Text>
                    </Box>
                    <Button
                      label={<Text><FontAwesome color='brand' icon={['fas', 'question-circle']} /></Text>}
                      plain
                      tip={{
                        content: (
                          <Box background={{ color: 'white' }} border={{ color: 'brand', size: 'small' }} direction='column' pad='small'>
                            <Text>High level strategies might include:</Text>

                            <Text>1. Stay calm and composed.</Text>
                            <Text>2. Ensure safety (yours and others).</Text>
                            <Text>3. Use clear, firm language.</Text>
                            <Text>4. Remove or avoid triggers if possible.</Text>
                            <Text>5. Set clear boundaries.</Text>
                            <Text>6. Offer a safe space or timeout.</Text>
                            <Text>7. Call for additional support if needed.</Text>
                            <Text>8. Provide reassurance.</Text>
                            <Text>9. Physical Intervention. </Text>
                            <Text>10. Restrictive Physical Intervention.</Text>

                          </Box>)
                        // dropProps: { background: 'red', extend: { border-width: '2px'; border-color: 'blue' } }
                      }}
                    />
                  </Box>)}
                name={questions[8].key}
              >
                {!editingDisabled && <TextInput
                  name={questions[8].key}
                />}
                {editingDisabled && <Text>{props.incidentValues?.[questions[8].key] || 'N/A'}</Text>}
              </FormField>

              {/* Recovery Behaviours Hidden on request */}
              {/* <FormField
                label={(
                  <Box fill direction='row' gap='small'>
                    <Text size='small'>{questions[10].questionText}</Text>
                    <Button
                      label={<Text><FontAwesome color='brand' icon={['fas', 'question-circle']} /></Text>}
                      plain
                      tip={{
                        content: (
                          <Box background={{ color: 'white' }} border={{ color: 'brand', size: 'small' }} direction='column' pad='small'>
                            <Text>Recovery behaviours might include:</Text>
                            <Text>Crying</Text>
                            <Text>Apologising</Text>
                            <Text>Defensive postures Body position & tension- arms crossed</Text>
                            <Text>Making personal and offensive remarks </Text>
                            <Text>Changes in eye contact</Text>
                            <Text>Breaking minor rules</Text>
                            <Text>Belligerent and abusive</Text>
                            <Text>Being quiet</Text>
                            <Text>Hiding face in hands</Text>
                            <Text>Pulling down hat</Text>
                            <Text>Tapping</Text>
                            <Text>Withdrawing from group</Text>
                            <Text>Refusing to speak or dismissive</Text>
                            <Text>Refusing to co-operate</Text>
                            <Text>Eye contact increased or decreased</Text>
                            <Text>Changes in breathing</Text>
                          </Box>)
                      }}
                    />
                  </Box>)}
                name={questions[10].key}
                required
              >
                <TextInput
                  name={questions[10].key}
                  type='text'
                />
              </FormField>

              <FormField
                label={<Box height='40px'><Text size='small'>{questions[11].questionText}</Text></Box>}
                name={questions[11].key}
                required
              >
                <TextInput
                  name={questions[11].key}
                  type='text'
                />
              </FormField>

              <FormField
                label={(
                  <Box fill direction='row' gap='small'>
                    <Text size='small'>{questions[12].questionText}</Text>
                  </Box>)}
                name={questions[12].key}
                required
              >
                <TextInput
                  name={questions[12].key}
                  type='text'
                />
              </FormField> */}
            </ResponsiveGrid>

            <CommentsForm formId={props.formId} userId={props.userId} section={props.section} isCollaborator={props.allowCollaboration} />

            <Divider color='primary' margin={{ top: 'medium', bottom: 'none' }} />

            <Box direction='row' gap='small' justify='between' margin={{ top: 'medium' }}>
              <ActionButton label='< Back' onClick={() => previousPage()} secondary />
              {!props.formId && <ActionButton icon={<FontAwesome icon={['fal', 'save']} color='#fff' />} label='Save for later' onClick={() => submitForm()} />}
              <ActionButton label='Next Page' onClick={() => nextPage()} primary />
            </Box>
          </Form>
        </Box>
      </Box>
    )}
    </ResponsiveContext.Consumer>
  )
}

export default BehaviourDetails
